import { Component } from '@angular/core';
import { MigrationsCucmHuntListsPollingContext } from '../services/cisco/migrations-cucm-hunt-lists-polling.context';
import { MigrationsCucmHuntListsContext } from '../services/cisco/migrations-cucm-hunt-lists.context';
import { MigrationsCucmNumberReportContext } from '../services/cisco/migrations-cucm-number-report.context';
import { MigrationsCucmNumberReportPollingContext } from '../services/cisco/migrations-cucm-number-report-polling.context';
import { MigrationsCucAutoAttendantsContext } from '../services/cisco/migrations-cuc-auto-attendants.context';
import { MigrationsCucAutoAttendantsPollingContext } from '../services/cisco/migrations-cuc-auto-attendants-polling.context';

@Component({
  selector: 'ziro-migrations-cisco',
  templateUrl: 'migrations-cisco.component.html',
  standalone: false,
  providers: [
    MigrationsCucmHuntListsPollingContext,
    MigrationsCucmHuntListsContext,
    MigrationsCucmNumberReportPollingContext,
    MigrationsCucmNumberReportContext,
    MigrationsCucAutoAttendantsContext,
    MigrationsCucAutoAttendantsPollingContext,
  ],
})
export class MigrationsCiscoComponent {}
